import { useElplanInfo } from 'api/elplan/elplan.api'
import { useHasPermission } from 'helpers/global.helper/global.helper'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import elplanStore from 'store/elplan/elplan'
import { Inline } from 'ui/atoms'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import InfoBanner from 'ui/components/InfoBanner/InfoBanner'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import SystemMessageBanner from 'ui/components/SystemMessageBanner/SystemMessageBanner'
import View from 'ui/components/View/View'
import { FormDatePickerPeriod } from 'ui/molecules/pickers/DatePicker/FormDatePickerPeriod'
import QueueProgressBar from 'ui/molecules/QueueProgressBar/QueueProgressBar'
import UiConfig from 'ui/uiConfig/UiConfig'
import Datetime from 'utils/datetime/datetime'
import { systemFeatureFlagActive } from 'utils/systemUtils'
import { useSnapshot } from 'valtio'

export default function ReviewForecasts(): ReactElement {
  const { t } = useTranslation()
  const [period, setPeriod] = useState({
    startTime: Datetime.getISONow(-168),
    endTime: Datetime.getISONow(0),
  })
  const { activeSystem } = useAuth()

  const fetchElplanValuesForReviewForecast = systemFeatureFlagActive(
    activeSystem,
    'electricity_plan_in_review_forecast_view'
  ) //using a similar feature flag as for optimize view since it is most likely that if user has access to optimize view and compare production plans he should also have access to see the elplan info in review forecasts view
  const hasElplanPermission = useHasPermission('view_electricity_trading_module')
  const showElplanInfo = fetchElplanValuesForReviewForecast && hasElplanPermission
  useElplanInfo(activeSystem?.id, showElplanInfo) //to fetch data for broker time

  const elplanSnap = useSnapshot(elplanStore)
  return (
    <View
      header={
        <ModuleHeader infoHeader={t('Review forecasts')}>
          <Inline flexEnd>
            {showElplanInfo && (
              <InfoBanner
                style={'info'}
                text={`${t('Electricity plan is sent at')} ${elplanSnap.prettyBrokerDeadlineTime}`}
                variant="text"
              />
            )}
            <FormDatePickerPeriod
              granularity="minute"
              defaultPeriod={period}
              onSubmit={(period) => setPeriod(period)}
            />
          </Inline>
        </ModuleHeader>
      }
    >
      <SystemMessageBanner module="reviewforecasts" />
      <UiConfig
        type="review_forecasts"
        datasetStartTime={period.startTime}
        datasetEndTime={period.endTime}
        fallback={
          <UiConfig type={`followup_forecast`} datasetStartTime={period.startTime} datasetEndTime={period.endTime} />
        }
      />

      <QueueProgressBar />
    </View>
  )
}
